// Utilitaires Firebase pour la gestion des dossiers utilisateurs

/**
 * Vérifie si une chaîne ressemble à un UID Firebase
 */
export const isFirebaseUID = (str) => {
  if (!str || typeof str !== 'string') return false;
  // Les UIDs Firebase font généralement 28 caractères et contiennent des caractères alphanumériques
  return /^[a-zA-Z0-9]{20,}$/.test(str) && str.length >= 20;
};

/**
 * Sanitise un email pour créer un nom de dossier Firebase valide
 * Remplace @ par _ et les points par des tirets
 */
export const sanitizeEmailForFolder = (email) => {
  if (!email) return '';
  return email.toLowerCase().replace('@', '_').replace(/\./g, '-');
};

/**
 * Retourne le chemin du dossier utilisateur pour Firebase Storage
 * Utilise l'email sanitisé pour les nouveaux utilisateurs
 */
export const getUserFolderPath = (user) => {
  if (!user) return '';
  
  // Si l'utilisateur a un email, utiliser l'email sanitisé
  if (user.email) {
    const sanitizedEmail = sanitizeEmailForFolder(user.email);
    return `recordings/${sanitizedEmail}`;
  }
  
  // Fallback vers UID si pas d'email
  return `recordings/${user.uid}`;
};